/*
 * fn: encodeArrayBufferToBase64
 *
 * Encodes an array buffer to base64...
 *
 */
export const encodeArrayBufferToBase64 = (buffer: number[] | ArrayBuffer) => {
  let binary = ''
  const bytes = new Uint8Array(buffer)
  const len = bytes.byteLength
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i] || 0)
  }
  return btoa(binary)
}
